import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import SaldoOperasionalService from '../../services/saldoOperasionalServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk(
  'saldoOperasional/list',
  async ({ page, perPage, sort, orderBy, search, cabangId, month, year }, thunkAPI) => {
    try {
      const response = await SaldoOperasionalService.getList(page, perPage, sort, orderBy, search, cabangId, month, year);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createData = createAsyncThunk('saldoOperasional/create', async (data, thunkAPI) => {
  try {
    const response = await SaldoOperasionalService.create(data);
    thunkAPI.dispatch(setMessage({ message: 'Saldo operasional berhasil ditambahkan', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('saldoOperasional/read', async (id, thunkAPI) => {
  try {
    const response = await SaldoOperasionalService.read(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('saldoOperasional/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await SaldoOperasionalService.update(id, data);
    thunkAPI.dispatch(setMessage({ message: 'Saldo operasional berhasil diubah', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('saldoOperasional/delete', async (id, thunkAPI) => {
  try {
    const response = await SaldoOperasionalService.del(id);
    thunkAPI.dispatch(setMessage({ message: 'Saldo operasional berhasil dihapus', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getRemainingBalance = createAsyncThunk(
  'saldoOperasional/getRemainingBalance',
  async ({ cabangId, month, year }, thunkAPI) => {
    try {
      const response = await SaldoOperasionalService.getRemainingBalance(cabangId, month, year);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getAllRemainingBalance = createAsyncThunk(
  'saldoOperasional/getAllRemainingBalance',
  async ({ month, year }, thunkAPI) => {
    try {
      const response = await SaldoOperasionalService.getAllRemainingBalance(month, year);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getTopupDetail = createAsyncThunk(
  'saldoOperasional/getTopupDetail',
  async ({ cabangId, month, year }, thunkAPI) => {
    try {
      const response = await SaldoOperasionalService.getTopupDetail(cabangId, month, year);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getListArchive = createAsyncThunk(
  'saldoOperasional/getListArchive',
  async ({ page, perPage, sort, orderBy, search, cabangId, startDate, endDate, createdBy }, thunkAPI) => {
    try {
      const response = await SaldoOperasionalService.getListArchive(
        page,
        perPage,
        sort,
        orderBy,
        search,
        cabangId,
        startDate,
        endDate,
        createdBy
      );
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = error.response?.data?.message || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const changeStatus = createAsyncThunk('saldoOperasional/changeStatus', async ({ id, status }, thunkAPI) => {
  try {
    const response = await SaldoOperasionalService.changeStatus(id, status);
    thunkAPI.dispatch(setMessage({ message: 'Status berhasil diubah', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const permanentDelete = createAsyncThunk('saldoOperasional/permanentDelete', async (id, thunkAPI) => {
  try {
    const response = await SaldoOperasionalService.permanentDelete(id);
    thunkAPI.dispatch(setMessage({ message: 'Data berhasil dihapus permanen', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = error.response?.data?.message || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = {
  isLoading: false,
  list: [],
  data: null,
  balanceData: null,
  allBalanceData: null,
  topupDetail: null,
  archiveList: [],
  error: null
};

const saldoOperasionalSlice = createSlice({
  name: 'saldoOperasional',
  initialState,
  reducers: {
    clearData: (state) => {
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(getList.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(createData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(readData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(readData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getRemainingBalance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRemainingBalance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.balanceData = action.payload;
      })
      .addCase(getRemainingBalance.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getAllRemainingBalance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllRemainingBalance.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allBalanceData = action.payload;
      })
      .addCase(getAllRemainingBalance.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getTopupDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTopupDetail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.topupDetail = action.payload;
      })
      .addCase(getTopupDetail.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.archiveList = action.payload;
      })
      .addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(permanentDelete.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(permanentDelete.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(permanentDelete.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

export const { clearData } = saldoOperasionalSlice.actions;
const { reducer } = saldoOperasionalSlice;
export default reducer;

